// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__7DW1z","checked":"Checkbox_checked__2Gh-t","checkbox":"Checkbox_checkbox__2LdRR"};